import {getConfig} from "../utils/envUtil";
import {LoginContent} from "../model/RegionLoginContent.model";
import {ApiBase} from "./ApiBase";
import {AxiosResponse} from "axios";

export class LoginContentApi {
    static carouselImageUrl(imageDocumentId: number): string {
        return `${getConfig().FRONTEND_CONFIG_BACKEND_URL}/login-content/image/${imageDocumentId}`;
    }

    public static getPublishedLoginContent(testCountry?: string, testLang?: string)
        : Promise<LoginContent | null> {
        const params = new URLSearchParams();
        if (testCountry) params.append("testCountry", testCountry);
        if (testLang) params.append("testLang", testLang);
        const query = params.toString() ? `?${params.toString()}` : "";
        return ApiBase.processGetUnwrapped(`/login-content${query}`,
            (response: AxiosResponse): LoginContent | null => {
                return response.data || null;
            }
        );
    }
}